import { delegationLabel, cityLabel } from "./labels";

// "Pourquoi cette annonce": a sentence built only from the facts computed by the server-side score
// (no model is called). Positive facts are joined with the language's list format, gaps follow as sentences.
export function explainMatch(t, match, language = "fr") {
  const { listing, reasons = [] } = match;
  const locale = language === "ar-TN" ? "ar" : language;
  let join;
  try { join = new Intl.ListFormat(locale, { style: "long", type: "conjunction" }); } catch { join = null; }
  const list = (items) => (join ? join.format(items) : items.join(", "));
  const place = (value) => delegationLabel(t, listing.city, value);
  const attribute = (code) => t(`propertyRequest.attribute.${code}`);
  const positives = [];
  const gaps = [];
  for (const reason of reasons) {
    const params = { percent: reason.percent, count: reason.count };
    switch (reason.code) {
      case "budgetWithin": positives.push(t("propertyRequest.why.budget")); break;
      case "locationExact": positives.push(t("propertyRequest.why.place", { place: place(reason.value) })); break;
      case "locationCity": positives.push(t("propertyRequest.why.place", { place: cityLabel(t, reason.value) })); break;
      case "surfaceWithin": positives.push(t("propertyRequest.why.surface")); break;
      case "bedroomsOk": positives.push(t("propertyRequest.why.bedrooms")); break;
      case "attributes": positives.push(t("propertyRequest.why.attributes", { items: list(reason.values.map(attribute)) })); break;
      case "locationSameCity": gaps.push(t("propertyRequest.why.locationSameCity", { place: place(reason.value) })); break;
      case "attributesMissing": gaps.push(t("propertyRequest.why.attributesMissing", { items: list(reason.values.map(attribute)) })); break;
      case "budgetAbove": case "budgetBelow": case "priceUnknown": case "surfaceBelow": case "surfaceAbove":
      case "surfaceUnknown": case "bedroomsMissing": case "typeOther": case "locationOther":
        gaps.push(t(`propertyRequest.why.${reason.code}`, params)); break;
      default: break; // "type" is implied by the listing card
    }
  }
  return [positives.length ? t("propertyRequest.why.matches", { items: list(positives) }) : "", ...gaps].filter(Boolean).join(" ");
}
